<template>
    <div style="padding:20px">
        <div >
            <a-input v-model:value="queryParam.queryTxt" style="width:300px" placeholder="请输入商品标题 / 商品ID / 店铺名称" />

            <a-button :loading="loading" @click="query(1)" style="float:right;margin-right:20px" type="primary">
                <template #icon><SearchOutlined /></template>
                搜索
            </a-button>
        </div>
        <div style="margin-top:20px">
            <a-table :loading="loading"  :scroll="{ y: tableHeight }"  @change="handleTableChange" :pagination="pagination" :dataSource="list" :columns="columns" >
                <template #bodyCell="{ column, text ,record}">
                    <template v-if="column.key === 'showPrice'">
                        <span style="font-weight:600">
                            ￥ {{text.toFixed(2)}}
                        </span>
                    </template>
                    <template v-else-if="column.key === 'img'" >
                        <a-image
                        style="width:100px;height:100px"
                            :src="text"
                            fallback="data:image/png;base64,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"

                        />
                    </template>
                    <template v-else-if="column.key === 'expandImg'" >
                        <a-image
                        style="width:100px;height:100px"
                            :src="text"
                            fallback="data:image/png;base64,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"

                        />
                    </template>
                    <template v-else-if="column.key === 'action'" >
                        <a-button @click="edit(record)" type="dashed" shape="circle">
                            <template #icon><edit-outlined /></template>
                        </a-button>
                    </template>
                    <template v-else-if="column.key === 'title'" >
                        <a target="_blank" :href="record.Url">{{record.Title}}</a>
                    </template>
                </template>
                
            </a-table>
        </div>
        <a-modal :confirmLoading="operateing" v-model:visible="visible" title="商品信息" @ok="ok" style="width:500px" ok-text="确认" cancel-text="取消">
            <div>
                <a-form
                
                    :model="model"
                    name="basic"
                    ref="form"
                    :label-col="{ span: 5 }"
                    :wrapper-col="{ span: 19 }"
                    autocomplete="off"
                >
                    <a-form-item
                    label="商品ID"
                    name="GoodsId"
                    :rules="[{ required: true, message: '请填写商品ID' }]"
                    >
                        
                        <a-input-group compact>
                            <a-input style="width:220px" readonly v-model:value="model.GoodsId" />
                            <a-button :loading="operateing" @click="getInfo(model.Url)" type="primary">获取商品信息</a-button>
                        </a-input-group>
                     </a-form-item>
                    <a-form-item
                    label="商品标题"
                    name="Title"
                    :rules="[{ required: true, message: '请填写商品标题' }]"
                    >
                        <a-textarea v-model:value="model.Title" placeholder="请输入商品标题" :rows="2" />
                    </a-form-item>

                    <a-form-item
                    label="主图"
                    name="Img"
                    :rules="[{ required: true, message: '请上传商品主图' }]"
                    >
                        <a-upload
                            name="avatar"
                            list-type="picture-card"
                            class="avatar-uploader"
                            :show-upload-list="false"
                            :action="baseUrl+'/system/PushImg'" :custom-request="ossDirectUpload"
                            @change="handleChange"
                        >
                            <img v-if="model.Img" style="width:100px;height:100px" :src="model.Img" alt="avatar" />
                            <div v-else>
                                <loading-outlined v-if="imgLoading"></loading-outlined>
                                <plus-outlined v-else></plus-outlined>
                                <div class="ant-upload-text">上传</div>
                            </div>
                        </a-upload>
                    </a-form-item>

                    <a-form-item
                    label="附图"
                    name="ExpandImg"
                    >
                        <a-upload
                            name="avatar"
                            list-type="picture-card"
                            class="avatar-uploader"
                            :show-upload-list="false"
                            :action="baseUrl+'/Goods/PushImg'" :custom-request="ossDirectUpload"
                            @change="handleChangeExpandImg"
                        >
                            <img v-if="model.ExpandImg" style="width:100px;height:100px" :src="model.ExpandImg" alt="avatar" />
                            <div v-else>
                                <loading-outlined v-if="expandImgLoading"></loading-outlined>
                                <plus-outlined v-else></plus-outlined>
                                <div class="ant-upload-text">上传</div>
                            </div>
                        </a-upload>
                    </a-form-item>

                    <a-form-item
                    label="显示价格"
                    name="Title"
                    :rules="[{ required: true, message: '请填写显示价格' }]"
                    >
                        <a-input-number style="width:140px" :min="0.1" v-model:value="model.ShowPrice" addon-before="￥" ></a-input-number>

                    </a-form-item>

                    <a-form-item
                    label="发货地"
                    name="Title"
                    :rules="[{ required: true, message: '请填写发货地' }]"
                    >
                        <a-input v-model:value="model.SendAddress" />
                    </a-form-item>

                </a-form>
            </div>
        </a-modal>
    </div>
</template>
<script>
import {  ref } from 'vue';
import { goodsGetReq,goodsUpdateReq,uri,goodsGetInfoByUrlReq} from '@/request.js';


// import { useRouter } from 'vue-router';
import { message } from 'ant-design-vue';
import { SearchOutlined,EditOutlined,LoadingOutlined,PlusOutlined} from '@ant-design/icons-vue';

export default {
    components: {
        SearchOutlined,EditOutlined,LoadingOutlined,PlusOutlined
    },
    setup(){
        const expandImgLoading=ref(false);
        const baseUrl=ref(uri);
        const imgLoading=ref(false);
        const form=ref();
        const model=ref({
            GoodsId:"",
            Title:"",
            Url:"",
            Img:"",
            ExpandImg:"",
            ShowPrice:0,
            SendAddress:""
        });
        let setRow={};
        const operateing=ref(false);
        const tableHeight=ref(0);
        tableHeight.value=document.documentElement.clientHeight-260;
        const visible=ref(false);
        const loading=ref(false);
        const pagination=ref({
            total: 0,
            pageSize: 50,
            showSizeChanger: false,
            showTotal: total => `共 ${total} 条`,  
        });
        const list=ref([]);
        const queryParam=ref({
            queryTxt:"",
        })
        const getInfo=(url)=>{
            operateing.value=true;
            goodsGetInfoByUrlReq({
                url:url
            },(res)=>{
                if(res.IsSuccess){
                    model.value.Title=res.Result.Title;
                    model.value.SendAddress=res.Result.SendAddress;
                    model.value.ShowPrice=res.Result.ShowPrice;
                    model.value.Img=res.Result.Img;
                    message.success("已获取最新商品信息");
                }else{
                    message.error(res.Message);
                }
                operateing.value=false;
            })
        }
        const ok=()=>{
            form.value
            .validate()
            .then(() => {
                operateing.value=true;
                goodsUpdateReq({goods:model.value},(res)=>{
                    if(res.IsSuccess){
                        setRow.Title=model.value.Title;
                        setRow.Img=model.value.Img;
                        setRow.ExpandImg=model.value.ExpandImg;
                        setRow.ShowPrice=model.value.ShowPrice;
                        setRow.SendAddress=model.value.SendAddress;
                        visible.value=false;
                        message.success("修改成功");
                    }else{
                        message.error("操作失败");
                    }
                    operateing.value=false;
                })
            })
            .catch(() => {
            });
        }
        const handleChange = info => {
            if (info.file.status === 'uploading') {
                imgLoading.value = true;
                return;
            }
            if (info.file.status === 'done') {
                if(info.file.response.IsSuccess){
                    model.value.Img=info.file.response.Message;
                }else{
                    message.error('上传失败');
                }
                imgLoading.value = false;
            }
            if (info.file.status === 'error') {
                imgLoading.value = false;
                message.error('上传失败');
            }
        };
        const handleChangeExpandImg = info => {
            if (info.file.status === 'uploading') {
                expandImgLoading.value = true;
                return;
            }
            if (info.file.status === 'done') {
                if(info.file.response.IsSuccess){
                    model.value.ExpandImg=info.file.response.Message;
                }else{
                    message.error('上传失败');
                }
                expandImgLoading.value = false;
            }
            if (info.file.status === 'error') {
                expandImgLoading.value = false;
                message.error('上传失败');
            }
        };
        const edit=(record)=>{
            setRow=record;
            model.value={
                GoodsId:record.GoodsId,
                Title:record.Title,
                Url:record.Url,
                Img:record.Img,
                ExpandImg:record.ExpandImg,
                ShowPrice:record.ShowPrice,
                SendAddress:record.SendAddress
            }
            visible.value=true;
        }

        const query=(index)=>{
            loading.value=true;
            goodsGetReq({
                pIndex:index,
                pSize:pagination.value.pageSize,
                queryTxt:queryParam.value.queryTxt,
                type:!queryParam.value.type?0:parseInt(queryParam.value.type)
            },(res)=>{
                list.value=res.Result;
                pagination.value.total=res.TotalCount;
                loading.value=false;
            })
        };
        const handleTableChange=(e)=>{
            query(e.current);
        };
        query(1);
        return{
            getInfo,
            handleChangeExpandImg,
            expandImgLoading,
            baseUrl,
            handleChange,
            imgLoading,
            model,
            form,
            ok,
            edit,
            operateing,
            tableHeight,
            visible,
            loading,
            handleTableChange,
            queryParam,
            list,
            query,
            pagination,
            columns: [
                {
                    title: '主图',
                    dataIndex: 'Img',
                    key: 'img',
                },
                {
                    title: '附图',
                    dataIndex: 'ExpandImg',
                    key: 'expandImg',
                },
                {
                    title: '所属店铺',
                    dataIndex: 'ShopName',
                    key: 'shopName',
                },
                {
                    title: '商品Id',
                    dataIndex: 'GoodsId',
                    key: 'GoodsId',
                },
                {
                    title: '商品标题',
                    dataIndex: 'Title',
                    key: 'title',
                },
                {
                    title: '显示价格',
                    dataIndex: 'ShowPrice',
                    key: 'showPrice',
                },
                {
                    title: '发货地址',
                    dataIndex: 'SendAddress',
                    key: 'sendAddress',
                },
                {
                    title: '操作',
                    key: 'action',
                },
                
            ],
        }
    }
}
</script>
<style scoped>
.remark{
    text-overflow:ellipsis;white-space:nowrap; overflow:hidden;width:100px;cursor:pointer
}
</style>